module.exports = "<!-- <p-growl [(value)]=\"messages\" [sticky]=\"true\"></p-growl> -->\r\n<!-- <p-messages [(value)]=\"messages\"></p-messages> -->\r\n\r\n<!-- <p-toast></p-toast> -->"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/notifications/notifications.component.html
// module id = ./src/app/core/notifications/notifications.component.html
// module chunks = main